import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import Tab from "semantic-ui-react/dist/commonjs/modules/Tab";
import Input from "semantic-ui-react/dist/commonjs/elements/Input";
import Accordion from "semantic-ui-react/dist/commonjs/modules/Accordion";
import { customer_voice } from "../../common/customer_voice";

export const voice = (type, pane, history) => {
  const pane_val1 = (
    <div className="tab_panel">
      <div className="collection">
        <div className="item">
          <div className="person">四人家族のサラリーマンＨ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_01_01.jpg)",
            }}
          />
          <div className="voice_info">家の建て替えが終わるまで一時収納</div>
        </div>
        <div className="item">
          <div className="person">大学四年生Ｙ様
          </div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_01_02.jpg)",
            }}
          />
          <div className="voice_info">大学4年生の家具家電の収納場所！</div>
        </div>
        <div className="item">
          <div className="person">お母さんに代わりに借りてもらったＹ様
          </div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_01_03.jpg)",
            }}
          />
          <div className="voice_info">留学の際の一時収納で利用！</div>
        </div>
        <div className="item">
          <div className="person">男の子2人のお父さんＫ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_01_04.jpg)",
            }}
          />
          <div className="voice_info">子供の五月人形をしまえてスッキリ！</div>
        </div>
        <div className="item">
          <div className="person">コンテナのお隣に住むＧ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_01_05.jpg)",
            }}
          />
          <div className="voice_info">普段使わない季節の物はコンテナに収納！</div>
        </div>
        <div className="item">
          <div className="person">20代サラリーマンＭ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_01_06.jpg)",
            }}
          />
          <div className="voice_info">彼女との同棲を解消して実家通いです。</div>
        </div>
      </div>
    </div>
  );

  const pane_val2 = (
    <div className="tab_panel">
      <div className="collection">
        <div className="item">
          <div className="person">コレクション集めが趣味Ｋ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_02_01.jpg)",
            }}
          />
          <div className="voice_info">コレクション置き場をついに移動！</div>
        </div>
        <div className="item">
          <div className="person">休みの日は必ず外出するＳ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_02_02.jpg)",
            }}
          />
          <div className="voice_info">マリンスポーツを入れてるんだよ</div>
        </div>
        <div className="item">
          <div className="person">バイク通勤のＮ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_02_03.jpg)",
            }}
          />
          <div className="voice_info">毎日の通勤は大好きなバイクで！</div>
        </div>
        <div className="item">
          <div className="person">30代ＯＬのＵ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_02_04.jpg)",
            }}
          />
          <div className="voice_info">趣味の作品を作るための道具入れです！</div>
        </div>
      </div>
    </div>
  );

  const pane_val3 = (
    <div className="tab_panel">
      <div className="collection">
        <div className="item">
          <div className="person">娘ももう大学生、Ｔ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_01.jpg)",
            }}
          />
          <div className="voice_info">娘との一生の思い出をとっておくために</div>
        </div>
        <div className="item">
          <div className="person">オークション大好きＳ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_02.jpg)",
            }}
          />
          <div className="voice_info">オークションに出す中古品の在庫置き場</div>
        </div>
        <div className="item">
          <div className="person">ドライブ好きのＯ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_03.jpg)",
            }}
          />
          <div className="voice_info">キャンプ用品を倉庫に入れて遊んでます。</div>
        </div>
        <div className="item">
          <div className="person">ママになって3年！Ｍ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_04.jpg)",
            }}
          />
          <div className="voice_info">二人目の子供はおさがりで！</div>
        </div>
        <div className="item">
          <div className="person">60代主婦Ｎ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_05.jpg)",
            }}
          />
          <div className="voice_info">家を売って新しい人生のスタート♪</div>
        </div>
        <div className="item">
          <div className="person">結婚1年目Ｙ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_06.jpg)",
            }}
          />
          <div className="voice_info">新婚の狭い新居のクローゼット</div>
        </div>
        <div className="item">
          <div className="person">世田谷暮らしのＯ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_07.jpg)",
            }}
          />
          <div className="voice_info">二家族で家賃は折半してます！</div>
        </div>
        <div className="item">
          <div className="person">都内勤務のＨ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_08.jpg)",
            }}
          />
          <div className="voice_info">通勤で使う自転車はトランクルームで！</div>
        </div>
        <div className="item">
          <div className="person">5人家族のお母様、Ｋ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_09.jpg)",
            }}
          />
          <div className="voice_info">我が家の万が一の防災倉庫！</div>
        </div>
        <div className="item">
          <div className="person">アーティストで俳優のＴ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_10.jpg)",
            }}
          />
          <div className="voice_info">増える洋服のウォークインクローゼット</div>
        </div>
        <div className="item">
          <div className="person">アラフォー主婦のＦ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_11.jpg)",
            }}
          />
          <div className="voice_info">父と同居することになりました</div>
        </div>
        <div className="item">
          <div className="person">小学生ママＡ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_03_12.jpg)",
            }}
          />
          <div className="voice_info">娘の部屋
            を作ろうと思ったの！</div>
        </div>
      </div>
    </div>
  );

  const pane_val4 = (
    <div className="tab_panel">
      <div className="collection">
        <div className="item">
          <div className="person">住宅販売会社のＹ社</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_01.jpg)",
            }}
          />
          <div className="voice_info">会社を広くするために利用しています。</div>
        </div>
        <div className="item">
          <div className="person">事業拡大をしたK社</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_02.jpg)",
            }}
          />
          <div className="voice_info">建築資材を収納し、拠点の一つとして！</div>
        </div>
        <div className="item">
          <div className="person">弁護士事務所勤務のＫ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_03.jpg)",
            }}
          />
          <div className="voice_info">重要書類の収納スペースとして利用してます。</div>
        </div>
        <div className="item">
          <div className="person">リサイクルショップ経営Ｏ社</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_04.jpg)",
            }}
          />
          <div className="voice_info">溜りに溜まる在庫を注文されるまで！</div>
        </div>
        <div className="item">
          <div className="person">普段は会社員のＷ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_05.jpg)",
            }}
          />
          <div className="voice_info">音楽仲間とシェアして楽器をいれてます。</div>
        </div>
        <div className="item">
          <div className="person">サークル代表Ｋ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_06.jpg)",
            }}
          />
          <div className="voice_info">映画製作サークルの小道具部屋です。</div>
        </div>
        <div className="item">
          <div className="person">店舗経営をしているＭ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_07.jpg)",
            }}
          />
          <div className="voice_info">お店のリニューアルに伴い荷物を移動！</div>
        </div>
        <div className="item">
          <div className="person">受注仕事をしている職人Ｙ様</div>
          <div
            className="image"
            style={{
              backgroundImage:
                "url(resource/img/static/voice2/detail_04_08.jpg)",
            }}
          />
          <div className="voice_info">道具を置いて営業拠点として活用中！</div>
        </div>
      </div>
    </div>
  );

  const pane_1 = <div>{pane_val1}</div>;
  const pane_2 = <div>{pane_val2}</div>;
  const pane_3 = <div>{pane_val3}</div>;
  const pane_4 = <div>{pane_val4}</div>;

  const panes = [
    {
      menuItem: "一時利用",
      pane: {
        key: "pane_1",
        content: pane_1,
      },
    },
    {
      menuItem: "趣味",
      pane: {
        key: "pane_2",
        content: pane_2,
      },
    },
    {
      menuItem: "普段遣い",
      pane: {
        key: "pane_3",
        content: pane_3,
      },
    },
    {
      menuItem: "法人・団体",
      pane: {
        key: "pane_4",
        content: pane_4,
      },
    },
  ];

  //          <Tab panes={panes} activeIndex={bookmark} renderActiveOnly={false} />
  let bookmark = 0;
  switch(pane){
    case 'moving': 
      document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様の声｜一時利用・季節のものを収納';
      bookmark=0;
      break;
    case 'season':
      document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様の声｜普段遣いの利用'; 
      bookmark=2; 
      break;
    case 'hobby': 
      document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様の声｜趣味のものを収納';
      bookmark=1; 
      break;
    case 'organization': 
      document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様の声｜法人・団体の利用'; 
      bookmark=3; 
      break;
    default: 
      document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様の声｜一時利用・季節のものを収納';
      bookmark=0;
      break;
  }

  const onTabChange = (event, data) => {
    console.log(event, data);
    const nextTabType = ['moving', 'hobby', 'season', 'organization'][data.activeIndex]
    history.push(`/voice2/${nextTabType}/`, { linkType: 'tab' });
  }

  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "お客様の声" }])}
      
      <div className="voice">
        <div className="toppanel">
          <div>
            <div className="title">お客様の声</div>
            <div className="text">
              <span>ハローストレージをご利用中のお客様の声を</span>
              <span>ご紹介します。</span>
              <span>トランクルーム選びの参考になさってください。</span>
            </div>
          </div>
        </div>
        <div className="content">
          <Tab onTabChange={onTabChange} panes={panes} activeIndex={bookmark==null ? 0: parseInt(bookmark)} renderActiveOnly={false} />
          <div className="customer_voice_helper">{customer_voice(type, true)}</div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/voice.jsx